import Button from '@/components/Buttons/Button';
import Edit from '@/images/Edit.svg';
import styled from '@emotion/styled';

// todo - should be replaced to new white button
const StyledButton = styled(Button)<{ white?: boolean }>`
    background-color: ${({ theme, white }) => white && theme.colors.white};
    color: ${({ theme, white }) => white && theme.colors.black[800]};
    border-color: ${({ theme, white }) => white && theme.colors.black[300]};

    :hover {
        border-color: ${({ theme, white }) => white && theme.colors.black[300]} !important;
    }

    width: 89px;

    img {
        width: 18px;
    }
`;

interface Props {
    onClick: (e: any) => void;
    white?: boolean;
}

export const AgentEditButton = ({ onClick, white }: Props) => {
    return (
        <StyledButton color="secondary" variant="outlined" startIcon={<img src={Edit} />} onClick={onClick} white={white}>
            Edit
        </StyledButton>
    );
};
